import * as React from 'react';
import {Fragment} from 'react';
import * as moment from "moment";
import {connect} from "react-redux";
import {compose} from "redux";
import {withTranslation} from "react-i18next";

import styles from './style.css';
import StickersComponentsScannerHeader from "../../components/scanner-header";
import StickersComponentsMediaPhoto from "../../components/media-photo";

import StickersComponentsMediaAudio from "../../components/media-audio";
import StickersComponentsMediaVideo from "../../components/media-video";
import UQButton from "../../../../uq-ui/components/button";
import {currentUserInfoSelector} from "../../../../auth/store/auth-user/selectors";
import {mediaAudioStateSelector} from "../../../store/media-audio/selectors";
import {mediaPhotoStateSelector} from "../../../store/media-photo/selectors";
import {mediaVideoStateSelector} from "../../../store/media-video/selectors";
import {
  createLlamaActiveThemeSelector,
  createLlamaFormSelector,
  createLlamaShowThemeSelector,
  createLlamaStateSelector, createLlamaTypeSelector, createStickerIdSelector, createStickerItemIdSelector
} from "../../../store/create-llama/selectors";
import {StickerFormatEnum} from "../../../domain/enums/StickerFormatEnum";
import {checkStepValidation, saveSticker} from "../../../store/create-llama/actions";
import {StickerCreateStepEnum} from "../../../domain/enums/StickerCreateStepEnum";
import Div100vh from "../../../../uq-ui/components/div-100";
import ConfirmModal from "../../../../uq-ui/components/confirm-modal";
import {getTextDirection} from "../../../../uq-ui/helpers/messageDirection";
import TextWithLinks from '../../../../uq-ui/components/text-with-links';
import goolgeAnalytics from '../../../../user/analytics/GoogleAnalytics';
import Icon from "../../../../icons/Icon";
import UiIcon from "../../../../uq-ui/components/ui-icon";
import ThemesScrollbar from "../../../../layout/ui/components/themed-scrollbar";
import classNames from "classnames";
import linearTranslation from "../../../../../utils/linear-translation";
import {withWindowSizeListener} from 'react-window-size-listener';
import {withTypeTranslation} from "../../../../../i18n";
class StickersScreensPreview extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      showConfirmModal: false,
    };
  }

  componentDidMount() {
    goolgeAnalytics.setCurrentScreen('web-preview');
    this.props.checkStepValidation(StickerCreateStepEnum.Preview);
  }

  onBackPressed = () => {
    const {stickerState, history, stickerId, stickerItemId} = this.props;
    const basePath = `/stickers/${stickerId}`
    switch (stickerState.form.format) {
      case StickerFormatEnum.Image:
        history.push(`${basePath}/new/photo`);
        break;
      case StickerFormatEnum.Audio:
        history.push(`${basePath}/new/audio`);
        break;
      case StickerFormatEnum.Video:
        history.push(`${basePath}/new/video`);
        break;
    }
  };

  onFinishPressed = () => {
    this.setState({showConfirmModal: true});
  };

  onConfirmPressed = () => {
    this.setState({showConfirmModal: false});
    this.props.saveSticker();
  };

  onEditThemePressed = () => {
    const {history, stickerId, stickerItemId} = this.props;
    history.push(`/stickers/${stickerId}/new/theme`);

  };

  onEditMessagePressed = () => {
    const {history, stickerId, stickerItemId} = this.props;
    history.push(`/stickers/${stickerId}/new/message`);

  };

  onModalClosePressed = () => {
    this.setState({showConfirmModal: false});
  };

  renderDate() {
    return (<div className={styles.dateString}>{this.getDateString()}</div>);
  }

  renderAuthor() {
    return (<div className={styles.author}>{this.getAuthorString()}</div>)
  }

  getAuthorString() {
    return this.props.currentUserInfo.display_name || '';
  }

  getDateString() {
    return moment().format('MMM YYYY');
  }

  renderGreeting(greeting_text) {
    const value = linearTranslation(window.innerHeight, 550, 80, 750, 160);
    let maxHeight = `${value}px`;
    const hasLinks = greeting_text.search(/https/ig) === -1;
    return (
      <ThemesScrollbar maxHeight={maxHeight}>
        {hasLinks ?
          greeting_text
          :
          <TextWithLinks linkStyle={{color: 'var(--c-accent)', textDecorationLine: 'underline', cursor: 'default'}}
                         text={greeting_text}/>
        }
      </ThemesScrollbar>
    );
  }

  renderEditIcon = (callback) => {
    return (
      <UQButton
        label={''}
        onPress={callback}
        containerClass={styles.themeEditContainer}
        theme="brand"
        justIcon={true}
        icon={<UiIcon name="pencil" size={16} strokeWidth={2.2} color="var(--c-on-accent)"/>}
      />
    );
  };


  renderTextContent() {
    const {greeting_text} = this.props.stickerData;
    const placeholderText = this.props.t2(this.props.stickerType, 'textPlaceholder');
    const displayText = greeting_text || placeholderText;
    const direction = getTextDirection(displayText);
    const greetingTextClasses = classNames({
      [styles.stickerText]: true,
      [styles.stickerTextPlaceholder]: !greeting_text
    });
    return (
      <div>
        <div style={{position: "relative", zIndex: 2}}>
          {this.renderEditIcon(this.onEditMessagePressed)}

          <div className={greetingTextClasses} style={{direction}} onClick={this.onEditMessagePressed}>
            {this.renderGreeting(displayText)}
          </div>

        </div>
        <div className={styles.authorDateContainer}>
          <div className={styles.authorDateInner}>
            {this.getAuthorString() && this.renderAuthor()}
            {this.renderDate()}
          </div>
        </div>
      </div>
    );
  }


  renderTheme() {
    if (!this.props.showTheme) {
      return null;
    }

    const theme = this.props.selectedTheme;
    const value = linearTranslation(window.innerHeight, 550, 10, 800, 0);
    const bottom = `${value}vh`;
    if (theme) {
      return (
        <div className={styles.themeWrap} style={{
          backgroundImage: `url(${theme.show.source.srcSvg})`,
          backgroundPosition: `0 ${bottom}` // cutting image to maintain non scrollable screen
        }} onClick={this.onEditThemePressed}>
          {this.renderEditIcon(this.onEditThemePressed)}
        </div>
      )
    }
    return null;
  }

  // Memorial photo: its own shape at full width, but at most 2/3 of the
  // screen when there is text, and always leaving room for the text and
  // date above the FINISH button.
  memorialPhotoMaxHeight() {
    const HEADER = 50, FINISH = 92;
    const screen = window.innerHeight;
    const hasText = !!this.props.stickerData.greeting_text;
    const textBlock = hasText ? 130 : 90;
    const room = screen - HEADER - FINISH - textBlock;
    return Math.max(160, hasText ? Math.min(Math.round(screen * 2 / 3), room) : room);
  }

  renderStickerMedia() {
    switch (this.props.stickerData.format) {
      case StickerFormatEnum.Image:
        const imageSource = this.props.mediaPhotoState.resultPhotoPath;
        return (<StickersComponentsMediaPhoto source={imageSource}
                                              isMemorial={ this.props.stickerType === 'MEMORIAL' }
                                              maxHeight={ this.props.stickerType === 'MEMORIAL' ? this.memorialPhotoMaxHeight() : undefined } />);
      case StickerFormatEnum.Audio:
        const audioSource = this.props.mediaAudioState.originAudioPath;
        const audioDuration = this.props.mediaAudioState.currentDuration;
        if (audioDuration != null && audioSource != null) {
          return (
            <StickersComponentsMediaAudio
              source={audioSource}
              duration={audioDuration}/>
          );
        }
        return null;
      // case StickerFormatEnum.Audio:
      //   const audioSource = this.props.mediaAudioState.originAudioPath;
      //   const audioDuration = this.props.mediaAudioState.currentDuration;
      //   if (audioDuration != null && audioSource != null) {
      //     return (
      //       <StickersComponentsMediaAudio
      //         source={audioSource}
      //         duration={audioDuration}/>
      //     );
      //   }
      //   return null;
      case StickerFormatEnum.Video:
        const videoSource = this.props.mediaVideoState.originVideoPath;
        const videoDuration = this.props.mediaVideoState.duration;
        const videoThumbnail = this.props.mediaVideoState.resultPreviewPath;
        return (<StickersComponentsMediaVideo
          duration={videoDuration}
          thumbnail={videoThumbnail}
          source={videoSource}/>);
      default:
        return null;
    }
  }

  render() {
    return (
      <Div100vh 
        className={styles.sticker}
        style={{minHeight: '100rvh', overflow: 'hidden'}} 
        withResize={false}
      >
        <StickersComponentsScannerHeader
          theme="brand"
          title={this.props.t('headerTitle')}
          showBackBtn={true}
          onBack={this.onBackPressed}/>
        <div style={{position: 'relative'}} className={"font-text"}>
          <div className={styles.stickerMediaContainer}>
            {this.renderStickerMedia()}
          </div>
          {this.renderTextContent()}
        </div>
        {this.renderTheme()}
        <div className={styles.bottom}>
          <UQButton label={this.props.t('finishBtn')}
                    containerStyle={{minWidth: 140}}
                    theme="brand"
                    onPress={this.onFinishPressed}/>
        </div>
        <ConfirmModal show={this.state.showConfirmModal}
                      title={this.props.t('sureTitle')}
                      confirmLabel={this.props.t('sureConfirm')}
                      onClose={this.onModalClosePressed}
                      onConfirm={this.onConfirmPressed}>
          {this.props.t('sureDesc')}
        </ConfirmModal>
      </Div100vh>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    stickerId: createStickerIdSelector(state),
    stickerItemId: createStickerItemIdSelector(state),
    currentUserInfo: currentUserInfoSelector(state),
    mediaAudioState: mediaAudioStateSelector(state),
    mediaPhotoState: mediaPhotoStateSelector(state),
    mediaVideoState: mediaVideoStateSelector(state),
    stickerData: createLlamaFormSelector(state),
    showTheme: createLlamaShowThemeSelector(state),
    stickerType: createLlamaTypeSelector(state),
    selectedTheme: createLlamaActiveThemeSelector(state),
    stickerState: createLlamaStateSelector(state),
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveSticker: () => dispatch(saveSticker()),
    checkStepValidation: (stepEnum) => dispatch(checkStepValidation(stepEnum)),
  }
};

export default compose(
  withTranslation('scr-new-sticker-preview'),
  connect(mapStateToProps, mapDispatchToProps),
  withTypeTranslation
)(withWindowSizeListener(StickersScreensPreview));
